import React, { useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Hero from './components/Hero';
import Quiz from './components/Quiz';
import AdminDashboard from './components/AdminDashboard';

function Landing() {
  const [showQuiz, setShowQuiz] = useState(false);
  return showQuiz ? <Quiz onClose={() => setShowQuiz(false)} /> : <Hero onStart={() => setShowQuiz(true)} />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
